import React from 'react';
import { TextField } from '@mui/material';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import useVehicleMakes from '../../resources/vehicleMakes/list';

const VehicleMake = ({ control, vehicleType }) => {
  const { data: { results: vehicleMakes } } = useVehicleMakes();

  if (vehicleType === 'automobile') {
    return (
      <ValidatedTextField
        name="vehicleMake"
        control={control}
        rules={{ required: 'This field is required.' }}
      >
        <TextField
          select
          fullWidth
          label="Make"
          SelectProps={{ native: true }}
        >
          <option value="" disabled aria-label="blank option" />
          {vehicleMakes.map((make) => (
            <option value={make.name} key={make.name}>{make.name}</option>
          ))}
        </TextField>
      </ValidatedTextField>
    );
  }

  return (
    <ValidatedTextField
      name="vehicleMake"
      control={control}
      rules={{ required: 'This field is required.' }}
    >
      <TextField fullWidth label="Make" />
    </ValidatedTextField>
  );
};

export default VehicleMake;
